export default __webpack_public_path__ + "locales/ro/EmptyTrashDialog.json?hash=b3e1a22dbc57cbd72feda4e6f4d19645";